import { css } from '@linaria/core';
import theme from '../../../theme';

export const variants = {
  unordered: css``,
  undecorated: css``,
  ruled: css``,
  ordered: css``,
};
export const components = {
  item: css``,
};

export const list = css`
  margin: 0;

  &.${variants.unordered} {
    list-style-type: disc;
  }

  &.${variants.undecorated} {
    list-style-type: none;
  }

  &.${variants.ruled} {
    list-style-type: none;
    margin-left: 0;
    border-bottom: ${theme.colors.neutral['50']};
    & & {
      border-bottom-width: 0;
      margin-top: 12px;
    }

    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 0;
  }

  &.${variants.ordered} {
    list-style-type: decimal;
  }

  & .${components.item} {
    &.${variants.ruled} {
      border-bottom: ${theme.colors.neutral['50']};
      padding-top: 12px;
      &:not(:has(&)) {
        padding-bottom: 12px;
      }

      &:last-child {
        border-bottom-width: 0;
      }

      padding: 0 0 18px 0;
    }

    &.${variants.ordered} {
      padding-left: 8px;
    }

    padding: 0;
  }

  & & {
    margin: 0 0 0 16px;
  }
`;
